/**
 * 文章排序Table
 */
import React, {Component} from 'react';
import DragSortTable from "../../../dragSortComponent/DragSortTable";
import moveIcon from "../../../../view/components/storySortModal/image/icon_5@2x.png";
import {formatDate} from "../../../../utils";
import {message} from "antd";

export default class ArticleSortTable extends DragSortTable {
    static propTypes = {};
    static defaultProps = {
        orderField: "orderField"
    };

    constructor(props) {
        super(props);
        this.state = {
            mediaId: props.mediaId,
            columnId: props.columnId
        }
    }

    getResultItem(item) {
        let currentItem = item;
        let hasMore = item.deliveryMediaFusionList && item.deliveryMediaFusionList.length > 0; // 是否多栏目
        if (hasMore && (item.columnId !== this.state.columnId)) {
            currentItem = item.deliveryMediaFusionList.find(item => item.columnId === this.state.columnId) || {};
        }
        return currentItem;
    }

    moveRow = (dragIndex, hoverIndex) => {
        const {sortList} = this.state;
        const {orderField} = this.props; //排序字段
        let dragRow = sortList[dragIndex];
        let hoverRow = sortList[hoverIndex];
        let dragRowCurrentItem = this.getResultItem(dragRow);
        let hoverRowCurrentItem = this.getResultItem(hoverRow);
        if(dragRowCurrentItem.top !== hoverRowCurrentItem.top){
            message.destroy();
            message.warn("置顶文章只能和置顶文章交换排序！");
            return;
        }
        if(dragRowCurrentItem.recommend !== hoverRowCurrentItem.recommend){
            message.destroy();
            message.warn("推荐文章只能和推荐文章交换排序！");
            return;
        }
        if (dragIndex < hoverIndex) {
            for (let index = dragIndex; index < hoverIndex; index++) {
                let indexRow = sortList[index];
                let indexRowOrder = indexRow[orderField];

                let nextIndex = index + 1;
                if (nextIndex > hoverIndex) {
                    nextIndex = dragIndex;
                }
                let nextRow = sortList[nextIndex];
                // 交换排序字段
                indexRow[orderField] = nextRow[orderField];
                nextRow[orderField] = indexRowOrder;

                // 交换下标
                sortList[index] = nextRow;
                sortList[nextIndex] = indexRow;
            }
        } else {
            for (let index = dragIndex; index > hoverIndex; index--) {
                let indexRow = sortList[index];
                let indexRowOrder = indexRow[orderField];

                let prevIndex = index - 1;
                if (prevIndex < hoverIndex) {
                    prevIndex = hoverIndex;
                }
                let preRow = sortList[prevIndex];
                // 交换排序字段
                indexRow[orderField] = preRow[orderField];
                preRow[orderField] = indexRowOrder;

                // 交换下标
                sortList[index] = preRow;
                sortList[prevIndex] = indexRow;
            }
        }
        this.setState({sortList});
    };

    getSortColumns = () => {
        const sortColumns = [
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
                width: "45%",
                ellipsis: true
            },
            {
                title: '置顶',
                dataIndex: 'top',
                key: 'top',
                render: (text, record, index) => {
                    return this.renderTopOrRecommend({
                        text: "top",
                        record,
                        stateKey: 'top'
                    })
                }
            },
            {
                title: '推荐',
                dataIndex: 'recommend',
                key: 'recommend',
                render: (text, record, index) => {
                    return this.renderTopOrRecommend({
                        text: "recommend",
                        record,
                        stateKey: 'recommend'
                    })
                }
            },
            {
                title: '发布时间',
                dataIndex: 'publishDate',
                key: 'publishDate',
                render: function (text, record, index) {
                    return (
                        <div>
                            {text ? formatDate(text).replaceAll('/', '-') : ""}
                        </div>
                    )
                }
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                render: () => {
                    return (
                        <div>
                            <img src={moveIcon} style={{width: 20, marginTop: -2, marginRight: 5}}/>
                            <span style={{color: '#0050B3'}}>拖动排序</span>
                        </div>
                    )
                }
            }
        ];
        this.setState({
            sortColumns
        });
    };

    renderTopOrRecommend({text, record, stateKey}) {
        // 0 未置顶 1 置顶  0 推荐  1 未推荐
        let isTop = text === "top" ? record.top : record.recommend;
        let hasMore = record.deliveryMediaFusionList && record.deliveryMediaFusionList.length > 0; // 是否多栏目
        // 如果不是主栏目则需要另外判断
        if (hasMore && (record.columnId !== this.state.columnId)) {
            // 寻找子栏目置顶状态
            let sonRecord = record.deliveryMediaFusionList.find(item => item.columnId === this.state.columnId) || {};
            isTop = sonRecord[stateKey]
        }
        return <span>{(isTop && isTop !== "0") ? "是" : "否"}</span>;
    }

    getSortList() {
        this.request({
            url: "/cm-sites-mmp/mf/all",
            body: {
                columnId: this.state.columnId,
                status: "已发布"
            },
            callBack: data => {
                let sortList = [];
                if (data && data.length) {
                    sortList = data;
                    sortList.forEach(item => {
                        let currentItem = (item.allColumnInfo && item.allColumnInfo.length && item.allColumnInfo.find(i => i.columnId === this.state.columnId)) || {};
                        item.sort = currentItem.sort;           //覆盖sort
                    });
                }
                this.setState({
                    sortList
                })
            }
        });
    }
}